import React from "react"
//import I18n from "i18n-js/index.js.erb"

class RadioSelect extends React.Component {

  constructor(props) {
    super(props)
    this.isSelected = this.isSelected.bind(this)
    this.buildRadioLabel = this.buildRadioLabel.bind(this)
  }

  render() {
    return (
      <div className="select-all-none" id="selected_rooms" style={{ marginBottom: 4 }}>
        <div className="item">
          <label>
            <input
              type="radio"
              checked={this.props.selected_input ? false : true}
              value={''}
              onChange={this.props.onChange}
              disabled={this.props.readOnly && this.props.selected_input}
            />
            <em>None</em>
          </label>
        </div>
        <hr />
        {this.renderForm(this.props.inputs)}
      </div>
    )
  }

  renderForm(inputs) {
    var self = this
    var rendered_inputs = inputs.map(input => self.renderInput(input))
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="items">
            {rendered_inputs}
          </div>
        </div>
      </div>
    )
  }

  renderInput(input) {
    return (
      <div className="item" key={input.id}>
        <label className={input.label_tertiary === 'Disabled' ? 'Disabled' : ''}>
          <input
            type="radio"
            value={input.id}
            checked={this.isSelected(input.id)}
            onChange={this.props.onChange}
            disabled={this.props.readOnly && !this.isSelected(input.id)}
          />
          {this.buildRadioLabel(input)}
          {input.status && input.status == 'disabled' ? <em>{` (${I18n.t('Disabled')})`}</em> : ""}
        </label>
      </div>
    )
  }

  buildRadioLabel(input) {
    var label = input.label_primary
    if (input.label_secondary && input.label_secondary.length) label += `  (${input.label_secondary})`
    return label
  }

  isSelected(id) {
    if (id === this.props.selected_input) return true
    else return false
  }

}

export default RadioSelect
